import React from 'react';
import * as css from './SendingTabs.css';
import SendingTabItem from './SendingTabItem';

function SendingTabs({currentTab, onTabClick, allowedList}: {currentTab: string, onTabClick: (tab: string) => void, allowedList: string[]}) {
    const tabsList = [
        ...(allowedList.includes('whatsapp') ? [{key: 'whatsapp', text: 'whatsapp', type: 'whatsapp'}] : []),
        ...(allowedList.includes('email') ? [{key: 'email', text: 'email', type: 'email'}] : []),
        ...(allowedList.includes('sms') ? [{key: 'sms', text: 'sms', type: 'sms'}] : [])
    ];

    const handleTabClick = (tab) => {
        if(tab.disabled) return;
        onTabClick(tab.key);
    };

    return (
        <css.tabsContainer>
            <css.tabsMenu>
                {tabsList.map((tab) => (
                    <SendingTabItem
                        key={tab.key}
                        tab={tab}
                        currentTab={currentTab}
                        onTabClick={handleTabClick}
                    />
                ))}
            </css.tabsMenu>
        </css.tabsContainer>
    );
}

export default SendingTabs;
